import Head from "next/head";
import FestivalTimeline from "@components/timeline/FestivalTimeline";
import { Store } from "@store";
import { isLoggedIn } from "@utils/user/userCheck";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function FestivalTimelineFun({userData, lang}) {
  const { t } = useTranslation();
  const { dispatch } = useContext(Store);

  useEffect(() => {
    dispatch({ type: "SET_DATA", payload: { userData, lang } });
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <Head>
        <title>{t('festival-panchang-or-utsav-hindu-temple-online-puja-and-prasad')}</title>
        <meta
          name="keywords"
          content={t('utsav-utsavapp-applex-virtual-festivals-virtual-puja-upvote-puja-durja-puja-locate-various-puja-know-your-community-connect-with-community-festivals-community-platform-community-first-local-events-helping-others-communities-social-good-local-community-first-do-digital-community-based-community-events-community-pujo-india-events-community-events-local-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief')}
        />
        <meta
          name="description"
          content={t('utsav-is-india-and-apos-s-most-loved-puja-booking-app-offer-pujas-at-shaktipeeth-jyotirlingas-mandirs-of-kashi-vrindavan-ujjain-watch-puja-darshan-and-receive-holy-prasad-at-your-home-directly-from-temple')}
        />

        <meta property="og:title" content={t('utsav-app-my-temple-and-festivals')} />
        <meta
          property="og:description"
          content={t('utsav-is-india-and-apos-s-most-loved-puja-booking-app-offer-pujas-at-shaktipeeth-jyotirlingas-mandirs-of-kashi-vrindavan-ujjain-watch-puja-darshan-and-receive-holy-prasad-at-your-home-directly-from-temple')}
        />

        <meta property="og:url" content="https://utsavapp.in" />
        <meta
          property="og:image"
          content="https://yt3.ggpht.com/ytc/AKedOLQGbAKixMk6KYgpHzIhr8toTKk3RCuyzgPc989W=s900-c-k-c0x00ffffff-no-rj"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <FestivalTimeline />
    </>
  );

}

export async function getServerSideProps(context) {
  const { req, res, query } = context;
  const result = await isLoggedIn(req.headers.cookie, res);
  const userData = result.data;
  const lang = result.lang;

  return {
    props: {
      userData: userData,
      lang: lang,
    },
  };

}

